module.exports = __webpack_public_path__ + "static/satisfied-0860d9fe3e38dd20f48ccfb5d13ba007.svg";